// Temperature interval units with conversion factors to Kelvin (K)
// Note: Temperature INTERVAL conversion is LINEAR (not offset-based like absolute temperature)
// This is for temperature differences, not absolute temperatures
// 1 K = 1 °C = 1.8 °F = 1.8 °R = 0.8 °Ré
export const temperatureIntervalUnits = [
  { id: 'kelvin', name: 'Kelvin', symbol: 'K', plural: 'Kelvins', factor: 1 },
  { id: 'degree-celsius', name: 'Degree Celsius', symbol: '°C', plural: 'Degrees Celsius', factor: 1 },
  { id: 'degree-fahrenheit', name: 'Degree Fahrenheit', symbol: '°F', plural: 'Degrees Fahrenheit', factor: 5/9 },
  { id: 'degree-rankine', name: 'Degree Rankine', symbol: '°R', plural: 'Degrees Rankine', factor: 5/9 },
  { id: 'degree-reaumur', name: 'Degree Réaumur', symbol: '°Ré', plural: 'Degrees Réaumur', factor: 1.25 },
];

export const popularTemperatureIntervalConversions = [
  { from: 'degree-celsius', to: 'degree-fahrenheit' },
  { from: 'degree-fahrenheit', to: 'degree-celsius' },
  { from: 'kelvin', to: 'degree-celsius' },
  { from: 'degree-celsius', to: 'kelvin' },
  { from: 'degree-fahrenheit', to: 'kelvin' },
  { from: 'kelvin', to: 'degree-fahrenheit' },
];

export const getUnitById = (id) => temperatureIntervalUnits.find(unit => unit.id === id);

export const convertTemperatureInterval = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} temperature interval converter. Instantly convert temperature difference units and learn the conversion formula.`;
};
